export const SHORTLIST_CANDIDATE = "SHORTLIST_CANDIDATE";
export const PROGRAM_TO_UPDATE = "PROGRAM_TO_UPDATE";
export const SHOW_PROGRAM_UPDATE_MODAL = "SHOW_PROGRAM_UPDATE_MODAL";
